var map = {
	"../tab-home/tab-home.module": [
		"./src/app/tab-home/tab-home.module.ts",
		"tab-home-tab-home-module"
	],
	"../tab-mine/tab-mine.module": [
		"./src/app/tab-mine/tab-mine.module.ts",
		"tab-mine-tab-mine-module"
	],
	"../tab-records/tab-records.module": [
		"./src/app/tab-records/tab-records.module.ts",
		"tab-records-tab-records-module"
	],
	"./announcement-detail/announcement-detail.module": [
		"./src/app/announcement-detail/announcement-detail.module.ts",
		"announcement-detail-announcement-detail-module"
	],
	"./announcement/announcement.module": [
		"./src/app/announcement/announcement.module.ts",
		"announcement-announcement-module"
	],
	"./app-login/app-login.module": [
		"./src/app/app-login/app-login.module.ts",
		"app-login-app-login-module"
	],
	"./e-learning/e-learning.module": [
		"./src/app/e-learning/e-learning.module.ts",
		"e-learning-e-learning-module"
	],
	"./gov-reporting/gov-add/gov-add.module": [
		"./src/app/gov-reporting/gov-add/gov-add.module.ts",
		"gov-reporting-gov-add-gov-add-module"
	],
	"./gov-reporting/gov-reporting.module": [
		"./src/app/gov-reporting/gov-reporting.module.ts",
		"gov-reporting-gov-reporting-module"
	],
	"./hidden-danger-reporting/hidden-danger-reporting.module": [
		"./src/app/hidden-danger-reporting/hidden-danger-reporting.module.ts",
		"hidden-danger-reporting-hidden-danger-reporting-module"
	],
	"./immediate-inspection/immediate-inspection.module": [
		"./src/app/immediate-inspection/immediate-inspection.module.ts",
		"immediate-inspection-immediate-inspection-module"
	],
	"./immediate-inspection/inspection-form/add-action-page/add-action-page.module": [
		"./src/app/immediate-inspection/inspection-form/add-action-page/add-action-page.module.ts",
		"immediate-inspection-inspection-form-add-action-page-add-action-page-module"
	],
	"./immediate-inspection/inspection-form/add-finding-page/add-finding-page.module": [
		"./src/app/immediate-inspection/inspection-form/add-finding-page/add-finding-page.module.ts",
		"immediate-inspection-inspection-form-add-finding-page-add-finding-page-module"
	],
	"./immediate-inspection/inspection-form/inspection-form.module": [
		"./src/app/immediate-inspection/inspection-form/inspection-form.module.ts",
		"immediate-inspection-inspection-form-inspection-form-module"
	],
	"./incident-corrective-execution/incident-corrective-execution.module": [
		"./src/app/incident-corrective-execution/incident-corrective-execution.module.ts",
		"incident-corrective-execution-incident-corrective-execution-module"
	],
	"./incident-corrective-verification/incident-corrective-verification.module": [
		"./src/app/incident-corrective-verification/incident-corrective-verification.module.ts",
		"incident-corrective-verification-incident-corrective-verification-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./message-center/message-center.module": [
		"./src/app/message-center/message-center.module.ts",
		"message-center-message-center-module"
	],
	"./message-detail/message-detail.module": [
		"./src/app/message-detail/message-detail.module.ts",
		"message-detail-message-detail-module"
	],
	"./pic-single/pic-single.module": [
		"./src/app/pic-single/pic-single.module.ts",
		"pic-single-pic-single-module"
	],
	"./record-corrective/record-corrective.module": [
		"./src/app/record-corrective/record-corrective.module.ts",
		"default~record-corrective-record-corrective-module~record-government-record-government-module~record~044093fc",
		"common",
		"record-corrective-record-corrective-module"
	],
	"./record-government/record-government.module": [
		"./src/app/record-government/record-government.module.ts",
		"default~record-corrective-record-corrective-module~record-government-record-government-module~record~044093fc",
		"common",
		"record-government-record-government-module"
	],
	"./record-hidden-danger/record-hidden-danger.module": [
		"./src/app/record-hidden-danger/record-hidden-danger.module.ts",
		"default~record-corrective-record-corrective-module~record-government-record-government-module~record~044093fc",
		"common",
		"record-hidden-danger-record-hidden-danger-module"
	],
	"./record-inspection/record-inspection.module": [
		"./src/app/record-inspection/record-inspection.module.ts",
		"default~record-corrective-record-corrective-module~record-government-record-government-module~record~044093fc",
		"common",
		"record-inspection-record-inspection-module"
	],
	"./record-plan-inspection/record-plan-inspection.module": [
		"./src/app/record-plan-inspection/record-plan-inspection.module.ts",
		"record-plan-inspection-record-plan-inspection-module"
	],
	"./setting-host/setting-host.module": [
		"./src/app/setting-host/setting-host.module.ts",
		"setting-host-setting-host-module"
	],
	"./shared/components/preview-file/preview-file.module": [
		"./src/app/shared/components/preview-file/preview-file.module.ts",
		"shared-components-preview-file-preview-file-module"
	],
	"./shared/components/turn-to-send/turn-to-send.module": [
		"./src/app/shared/components/turn-to-send/turn-to-send.module.ts",
		"shared-components-turn-to-send-turn-to-send-module"
	],
	"./tab-calendar/tab-calendar.module": [
		"./src/app/tab-calendar/tab-calendar.module.ts",
		"tab-calendar-tab-calendar-module"
	],
	"./tabs/tabs.module": [
		"./src/app/tabs/tabs.module.ts",
		"tabs-tabs-module"
	],
	"./task-center/task-center.module": [
		"./src/app/task-center/task-center.module.ts",
		"task-center-task-center-module"
	],
	"./upload-compliance-documents/upload-compliance-documents.module": [
		"./src/app/upload-compliance-documents/upload-compliance-documents.module.ts",
		"upload-compliance-documents-upload-compliance-documents-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;